import { render, staticRenderFns } from "./categoryManage.vue?vue&type=template&id=e3b46b4a&scoped=true"
import script from "./categoryManage.vue?vue&type=script&lang=js"
export * from "./categoryManage.vue?vue&type=script&lang=js"
import style0 from "./categoryManage.vue?vue&type=style&index=0&id=e3b46b4a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b46b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3b46b4a')) {
      api.createRecord('e3b46b4a', component.options)
    } else {
      api.reload('e3b46b4a', component.options)
    }
    module.hot.accept("./categoryManage.vue?vue&type=template&id=e3b46b4a&scoped=true", function () {
      api.rerender('e3b46b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/dishGroupManage/categoryManage.vue"
export default component.exports